import PageKiosk from './components/Kiosk';

export default PageKiosk;
